import app from 'flarum/common/app';

app.initializers.add('foskym/flarum-activity-graph', () => {
  console.log('[foskym/flarum-activity-graph] Hello, forum and admin!');
});
